/**
 * ComprehensiveDashboardPage - Full system overview dashboard
 *
 * Surfaces the ComprehensiveDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides a unified view of all workflow types, metrics, and system status.
 *
 * Route: /admin/comprehensive
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconLayoutDashboard } from '@tabler/icons-react';

import { ComprehensiveDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function ComprehensiveDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="grape">
            <IconLayoutDashboard size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Comprehensive Dashboard</Title>
            <Text size="sm" c="dimmed">
              Unified view of all workflow types, metrics, and system status
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ComprehensiveDashboard />
    </Container>
  );
}

export default ComprehensiveDashboardPage;
